import CashiersTournament3 from './CashiersTournament3';
export default CashiersTournament3;
